import { render } from "./popUp2.vue?vue&type=template&id=007d3544&scoped=true"
import script from "./popUp2.vue?vue&type=script&lang=js"
export * from "./popUp2.vue?vue&type=script&lang=js"

import "./popUp2.vue?vue&type=style&index=0&id=007d3544&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007d3544"]])

export default __exports__